<template>
  <div>
    <v-data-table
      :headers="headers"
      max-width="100%"
      :items="volunteersHandler"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Volunteers</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
           <v-btn
            to="/volunteer/create"
            color="teal accent-4"
            depressed
            dark
            class="mb-1 mr-3"
          >
            <v-icon left dark>mdi-plus-circle-outline</v-icon>New
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.gender_name }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.education_status_name }}</td>
          <td>{{ item.occupation_name }}</td>
          <td>{{ item.remark }}</td>
          <td>
            <v-btn
              @click="goTrainingPage(item)"
              icon
              color="grey darken-1"
              class="white--text"
              depressed
            >
              <v-icon>
                mdi-notebook-edit-outline
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    volunteers: {
      type: Array,
    },
   
  },
  components: {},
  data: () => ({
    
    gender: [
      { id: 1, name: "male" },
      { id: 2, name: "female" },
    ],
    education_status: [
      { id: 1, name: "higher" },
      { id: 2, name: "primary" },
      { id: 3, name: "secondary" },
    ],
    occupation: [
      { id: 1, name: "AM" },
      { id: 2, name: "CHW" },
      { id: 3, name: "Other" },
    ],
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    headers: [
      { text: "No", value: "no" },
      { text: "Code", value: "code" },
      { text: "Name", value: "name" },
      { text: "Age", value: "age" },
      { text: "Gender", value: "gender_name" },
      { text: "Address", value: "address" },
      { text: "Phone", value: "phone" },
      { text: "Education Status", value: "education_status_name" },
      { text: "Occupation", value: "occupation_name" },
      { text: "Remark", value: "remark" },
      { text: "Training", value: "training" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    volunteersHandler() {
      const volunteers = this.volunteers.map((volunteer) => {
        const gender = this.gender.find((item) => {
          return volunteer.gender == item.id;
        });
        volunteer.gender_name = gender.name;

        const education_status = this.education_status.find((item) => {
          return volunteer.education_status == item.id;
        });
        volunteer.education_status_name = education_status.name;

        const occupation = this.occupation.find((item) => {
          return volunteer.occupation == item.id;
        });
        volunteer.occupation_name = occupation ? occupation.name : '';

        return volunteer;
      });
      return volunteers;
    },
  },
  methods: {
    
    goTrainingPage(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push(`/volunteer/trainings/${convertNumber}`);
    },
  },
};
</script>

<style scoped></style>
